import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'el-icon-s-home',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/competition-application',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Formularze zgłoszeniowe' },
    children: [
      {
        path: 'list',
        component: getView('CompetitionApplication/CompetitionApplicationList'),
        name: 'CompetitionApplication List',
        meta: { label: 'Lista zgłoszeń' }
      },
      {
        path: 'tasks/:id',
        component: getView(
          'CompetitionApplication/CompetitionApplicationDetail'
        ),
        name: 'CompetitionApplication Detail',
        meta: { label: 'Szczegóły formularza zgłoszeniowego' },
        props: true,
        hidden: true
      }
    ]
  },
  {
    path: '/exported-files',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Exporty' },
    children: [
      {
        path: 'exports',
        component: getView('ExportedFiles/ExportedFilesList'),
        name: 'ExportFiles List',
        meta: { label: 'Lista exportów' }
      }
    ]
  },
  {
    path: '/tasks',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Zadania' },
    children: [
      {
        path: 'tasks',
        component: getView('Tasks/TaskList'),
        name: 'Task List',
        meta: { label: 'Lista zadań' }
      },
      {
        path: 'tasks/:id',
        component: getView('Tasks/TaskDetail'),
        name: 'Task Detail',
        meta: { label: 'Zadania' },
        props: true,
        hidden: true
      }
    ]
  },
  // {
  //   path: '/pages',
  //   component: Home,
  //   iconCls: 'fa fa-desktop',
  //   meta: { label: 'Podstrony' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Pages/PagesList'),
  //       name: 'Pages List',
  //       meta: { label: 'Lista stron' }
  //     },
  //     {
  //       path: 'add',
  //       component: getView('Pages/PageForm'),
  //       name: 'Add Page',
  //       meta: { label: 'Dodaj stronę' }
  //     },
  //     {
  //       path: ':id',
  //       props: true,
  //       component: getView('Pages/PageForm'),
  //       name: 'Edit Page',
  //       hidden: true,
  //       meta: { label: 'Edytuj stronę' }
  //     }
  //   ]
  // },
  // {
  //   path: '/articles',
  //   component: Home,
  //   iconCls: 'fa fa-file-text-o',
  //   meta: { label: 'Artykuły' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Articles/ArticleList'),
  //       name: 'Article List',
  //       meta: { label: 'Lista artykułów' }
  //     },
  //     {
  //       path: 'add',
  //       component: getView('Articles/ArticleForm'),
  //       name: 'Add Article',
  //       meta: { label: 'Dodaj artykuł' }
  //     },
  //     {
  //       path: ':id',
  //       props: true,
  //       component: getView('Articles/ArticleForm'),
  //       name: 'Edit Article',
  //       hidden: true,
  //       meta: { label: 'Edytuj artykuł' }
  //     }
  //   ]
  // },
  // {
  //   path: '/images',
  //   component: Home,
  //   iconCls: 'fa fa-image',
  //   meta: { label: 'Zdjęcia' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Image/ImageList'),
  //       name: 'Image List',
  //       meta: { label: 'Lista zdjęć' }
  //     },
  //     {
  //       path: 'add',
  //       component: getView('Image/ImageForm'),
  //       name: 'Add Image',
  //       meta: { label: 'Dodaj zdjęcie' }
  //     },
  //     {
  //       path: 'catalogs',
  //       component: getView('Image/CatalogList'),
  //       name: 'Catalog List',
  //       meta: { label: 'Lista katalogów' }
  //     },
  //     {
  //       path: 'catalogs/add',
  //       component: getView('Image/CatalogForm'),
  //       name: 'Add Catalog',
  //       meta: { label: 'Dodaj katalog' }
  //     },
  //     {
  //       path: 'catalogs/:id',
  //       props: true,
  //       component: getView('Image/CatalogForm'),
  //       name: 'Edit Catalog',
  //       hidden: true,
  //       meta: { label: 'Edytuj katalog' }
  //     },
  //     {
  //       path: ':id',
  //       props: true,
  //       component: getView('Image/ImageForm'),
  //       name: 'Edit Image',
  //       hidden: true,
  //       meta: { label: 'Edytuj zdjęcie' }
  //     }
  //   ]
  // },
  // {
  //   path: '/attachments',
  //   component: Home,
  //   iconCls: 'fa fa-download',
  //   meta: { label: 'Załączniki' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Attachments/AttachmentsList'),
  //       name: 'Attachments List',
  //       meta: { label: 'Lista załączników' }
  //     }
  //   ]
  // },
  // {
  //   path: '/menu',
  //   component: Home,
  //   iconCls: 'fa fa-bars',
  //   meta: { label: 'Menu' },
  //   children: [
  //     {
  //       path: 'menu',
  //       component: getView('Menus/MenuForm'),
  //       name: 'Edit Menu',
  //       meta: { label: 'Edytuj menu główne' }
  //     },
  //     {
  //       path: 'footer-menu',
  //       component: getView('Menus/FooterMenuForm'),
  //       name: 'Edit FooterMenu',
  //       meta: { label: 'Edytuj stopkę' }
  //     }
  //   ]
  // },
  // {
  //   path: '/users',
  //   component: Home,
  //   iconCls: 'fa fa-group',
  //   meta: { label: 'Użytkownicy' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('User/UserList'),
  //       name: 'User List',
  //       meta: { label: 'Lista użytkowników' }
  //     },
  //     {
  //       path: 'add',
  //       component: getView('User/UserForm'),
  //       name: 'Add User',
  //       meta: { label: 'Dodaj użytkownika' }
  //     },
  //     {
  //       path: ':id',
  //       props: true,
  //       component: getView('User/UserForm'),
  //       name: 'Edit User',
  //       hidden: true,
  //       meta: { label: 'Edytuj użytkownika' }
  //     }
  //   ]
  // },
  // {
  //   path: '/settings',
  //   component: Home,
  //   iconCls: 'fa fa-cog',
  //   meta: { label: 'Ustawienia' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Settings/SettingsForm'),
  //       name: 'Settings Form',
  //       meta: { label: 'Konfiguracja strony' }
  //     }
  //   ]
  // },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Panel administracyjny`
    : 'Panel administracyjny'
  next()
})

export default router
